export const Ticket_Variables = {
	others: {
		ticketItemId: 0,
		name: "Others",
		departmentId: 0,
	},
	UrgencyValues: [
		{ value: 0, label: "High" },
		{ value: 1, label: "Medium" },
		{ value: 2, label: "Low" },
	],
	feedbackPriority: [
		{ value: 1, label: "High" },
		{ value: 2, label: "Medium" },
		{ value: 3, label: "Low" },
	],
	feedbackStatus: [
		{ value: 1, label: "Pending" },
		{ value: 2, label: "InProgress" },
		{ value: 3, label: "Completed" },
		{ value: 4, label: "Deferred" },
	],
	devsList: [
		{ value: 370, label: "Kanza Shahid" },
		{ value: 360, label: "Sawaid" },
		{ value: 358, label: "Abdur Rehman" },
		{ value: 215, label: "Ahtesham ul Haq" },
		{ value: 173, label: "Muhammad Shahzad" },
		{ value: 251, label: "Muhammad Awais Iqbal" },
		{ value: 180, label: "Syed Abdullah Bin Zubair" },
		{ value: 137, label: "Arif Ullah Khan" },
		{ value: 393, label: "Zeeshan Ali" },
	],
	react_select_style: {
		control: (base, state) => ({
			...base,
			borderRadius: 0,
			outline: "0 !important",

			width: "100%",
			borderColor: state.isFocused ? null : null,
			boxShadow: state.isFocused ? null : null,
			border: "0",
			minHeight: "27px",
			height: "27px",
			fontSize: "12px",
			color: "#7ebfc0",
		}),
		indicatorSeparator: (base) => ({
			...base,
			display: "none",
		}),
		dropdownIndicator: (base) => ({
			...base,
			color: "#7ebfc0",
			marginTop: "-9px",
		}),
		clearIndicator: (base) => ({
			color: "#7ebfc0",
			marginBottom: "9px",
		}),
		valueContainer: (base) => ({
			...base,
			position: "initial !important",
		}),
		singleValue: (base) => ({
			...base,
			color: "#112f41",
		}),
	},
};
